<template lang="pug">
div
  v-fade-transition
    .dashboard-filters-sheet__overlay(
      v-if="value",
      @click="$emit('input', false)"
    )

  v-slide-x-transition
    v-sheet.dashboard-filters-sheet(
      v-if="value",
      color="white",
      elevation="20"
    )
      .dashboard-filters-sheet__header
        .dashboard-filters-sheet__title {{ title }}
        v-btn(icon, @click="$emit('input', false)")
          v-icon mdi-close

      .dashboard-filters-sheet__body
        v-autocomplete.dashboard-filters-sheet__field(
          v-for="field in filterFieldConfigs",
          :key="field.key",
          dense,
          outlined,
          :label="field.label",
          return-object,
          :items="field.items",
          item-text="text",
          item-value="value",
          :value="selectedFilters[field.key]",
          @input="updateFilter(field.key, $event)",
          multiple,
          clearable,
          hide-details,
          :no-data-text="field.noDataText"
        )
          template(v-slot:selection="{ item, index }")
            template(v-if="index === 0")
              span {{ item.text }}
            template(v-else-if="index === 1")
              span.grey--text.text-caption.pl-2 (+{{ selectedFilters[field.key].length - 1 }} outros)

      .dashboard-filters-sheet__actions
        v-btn.dashboard-filters-sheet__action-button(outlined, color="primary", @click="$emit('clear')") {{ clearText }}
        v-btn.dashboard-filters-sheet__action-button(color="primary", @click="$emit('apply')") {{ applyText }}
</template>

<script>
export default {
  name: "FiltersSheet",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Outros filtros"
    },
    clearText: {
      type: String,
      default: "Limpar tudo"
    },
    applyText: {
      type: String,
      default: "Buscar"
    },
    filterFieldConfigs: {
      type: Array,
      default: () => []
    },
    selectedFilters: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    updateFilter(key, value) {
      this.$emit("update:selectedFilters", {
        ...this.selectedFilters,
        [key]: value
      });
    }
  }
};
</script>

<style scoped>
.dashboard-filters-sheet__overlay {
  background: rgba(10, 31, 68, 0.22);
  inset: 0;
  position: absolute;
  z-index: 10;
}

.dashboard-filters-sheet {
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  max-width: 360px;
  position: absolute;
  top: 0;
  width: 360px;
  z-index: 11;
}

.dashboard-filters-sheet__header {
  align-items: center;
  border-bottom: 1px solid #d9e2ef;
  display: flex;
  justify-content: space-between;
  padding: 18px 20px;
}

.dashboard-filters-sheet__title {
  color: #173256;
  font-size: 17px;
  font-weight: 700;
}

.dashboard-filters-sheet__body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 20px 12px;
}

.dashboard-filters-sheet__field {
  margin-bottom: 16px;
}

.dashboard-filters-sheet__actions {
  border-top: 1px solid #d9e2ef;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 20px 20px;
}

.dashboard-filters-sheet__action-button {
  flex: 1 1 0;
  min-width: 0;
}

@media (max-width: 959px) {
  .dashboard-filters-sheet {
    max-width: 100%;
    width: 100%;
  }
}
</style>
